export class DialogEditConfig<T> {
  title?: string;
  //If it is a new Entry or not if the dialog needs it
  newEntry = false;
  loadObject?: boolean; //Fetch from server
  //Initial Object to be used to populate the form
  element: T;
  //Used by some dialogs to determine if it should save to server
  //E.G List would enable autosave since the List isn't managing the object
  //E.G. Form would disable auto save since the Form is managing the object
  autoSave? = false;
  autoClean? = true;
  //Filter is used for forms that need to restrict the data they are showing.
  filter?: T[] | string[] | number[];
  disabledFields?: (keyof T & string)[];

  //List of Field Names that should be hidden on the form
  //This allows for form reuse independent on how you got to the form.
  //E.G. Truck form link would hid the truckID field
  //Vice Versa: Truck Alias link would hide the truckAliasId field
  showOnly?: (keyof T & string)[];
  hideFields?: (keyof T & string)[];
  //For tab views, a default tab can be passed through instead of the default tab 0
  selectedTab?: string;

  //Use related Elements to pass related objects that are needed for the dialog
  //E.G Schedule Templates needs list of available Alt Weeks on that route
  //relatedElements = { altWeeks = [object1, object2,...]}
  relatedElements?: unknown;

  constructor(jsonData?: Partial<DialogEditConfig<T>>) {
    if (jsonData) {
      Object.assign(this, jsonData);
    }
  }
}
